module.exports = __webpack_public_path__ + "TextaNarrow-Heavy-webfont.250b92d009742892971e.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Heavy-webfont.ttf
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Heavy-webfont.ttf
// module chunks = styles